export default "__VITE_ASSET__285772b7__"